export enum enumBfeeSourceStatus {
  'Active' = 1,
  'Inactive'
}

export namespace enumBfeeSourceStatus {
  export function values() {
    return Object.keys(enumBfeeSourceStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

